import React from "react";
import { UserContext } from "app/context/useUser";
import jwt_decode from "jwt-decode";
import { AuthPayload } from "shared/models/models";
import defineAbilityFor, { IPermResponse } from "shared/models/defineAbility";

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const initialUser: AuthPayload = {
    sub: 0,
    email: "",
    lang: "en",
    ability: null,
    opr: false,
    own: false,
    adm: false,
    inv: false,
  };
  const [user, setUser] = React.useState(initialUser);

  const set = () => {
    const token = localStorage.getItem("accessToken");
    if (typeof token === "string" && token?.length > 10) {
      const jwt: AuthPayload = jwt_decode(token);
      setUser((prev) => ({
        ...prev,
        sub: jwt.sub,
        lang: jwt.lang,
        email: jwt.email,
        opr: jwt.opr,
        own: jwt.own,
        adm: jwt.adm,
        inv: jwt.inv,
        space: jwt.space,
      }));
    }
    const permString = localStorage.getItem("ability");
    if (typeof permString === "string" && permString?.length > 10) {
      const ability: IPermResponse[] = JSON.parse(permString);
      const abilty = defineAbilityFor(user, ability);
      setUser((prev) => ({
        ...prev,
        ability: abilty,
      }));
    }
  };

  return (
    <UserContext.Provider value={{ user, set }}>
      {children}
    </UserContext.Provider>
  );
};
